// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ConsentsController from "./consents_controller"
application.register("consents", ConsentsController)

import CookieConsentController from "./cookie_consent_controller"
application.register("cookie-consent", CookieConsentController)

import CountdownController from "./countdown_controller"
application.register("countdown", CountdownController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import QuickAmountController from "./quick_amount_controller"
application.register("quick-amount", QuickAmountController)

import RegistrationSuccessController from "./registration_success_controller"
application.register("registration-success", RegistrationSuccessController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import TranscriptionRowController from "./transcription_row_controller"
application.register("transcription-row", TranscriptionRowController)

import TranscriptionSearchController from "./transcription_search_controller"
application.register("transcription-search", TranscriptionSearchController)

import UploadController from "./upload_controller"
application.register("upload", UploadController)

import UserUpdatesController from "./user_updates_controller"
application.register("user-updates", UserUpdatesController)

import PromptModelController from "./prompt_model_controller"
application.register("prompt-model", PromptModelController)
